module.exports = __webpack_public_path__ + "img/ic_24_social_facebook.549b4b06.svg";